import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'SectionSeparator' })((theme) => ({
  textContent: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(18),
    textTransform: 'uppercase',
  },
  divider: {
    backgroundColor: theme.palette.divider,
  },
}));

export default useStyles;
